var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramEntertainment64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Entertainment64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 6.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(27.056441, 26.696840) rotate(45.000000) translate(-27.056441, -26.696840) translate(14.056441, 2.696840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0667756,47.0943396 C18.0667756,44.3850182 15.8704366,42.1886792 13.1611152,42.1886792 C10.4517938,42.1886792 8.25545482,44.3850182 8.25545482,47.0943396 L-2.13162821e-14,47.0943396 L-2.13162821e-14,15.6981132 L25.509434,15.6981132 L25.509434,47.0943396 L18.0667756,47.0943396 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61036692,4.26603197e-14 C7.57828393,0.226642244 7.56168967,0.458265796 7.56168967,0.693765144 C7.56168967,3.40308656 9.75802864,5.59942552 12.46735,5.59942552 C15.1766715,5.59942552 17.3730104,3.40308656 17.3730104,0.693765144 C17.3730104,0.458265796 17.3564162,0.226642244 17.3243332,4.29656311e-14 L25.509434,4.26325641e-14 L25.509434,15.6981132 L-2.13162821e-14,15.6981132 L-2.13162821e-14,4.26325641e-14 L7.61036692,4.26325641e-14 Z",
    id: "Combined-Shape",
    fill: "#FFCC00"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramEntertainment64);
export default __webpack_public_path__ + "static/media/pictogramEntertainment64.caa563bbfcda2fa1579c7973895d21c7.svg";
export { ForwardRef as ReactComponent };